import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $Price = styled('span')`
  && {
    color: ${({ theme }) => theme.colors.danger} !important;
  }
  margin-left: ${spacing(1.5)};
  span {
    color: inherit !important;
  }
`;

export const $Container = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${spacing('sm')};
  width: 100%;
`;
